import styled from 'styled-components';

import colors from '@constants/colors';

export const Container = styled.div`
  overflow-y: auto;
  position: relative;
  height: 100%;
  padding: 16px;
`;
